import React from "react";
import "./about.css";
import content from "../../content.json";
import RevealOnScroll from "../../utils/RevealOnScroll";

const About = () => {
  return (
    <section className="about-section" id="about">
      <div className="about-content">
        {/* LEFT SIDE */}
        <RevealOnScroll style={{ flex: '1 1 550px' }}>
          <div className="about-text">
            <h2>
              Who <span className="gradient-text">We Are</span>
            </h2>
            <p className="intro-text">
              {content.who_we_are.description1}
            </p>

            <p className="intro-text">
              {content.who_we_are.description2}
            </p>

            <ul className="about-list">
              <li>Innovation-first engineering</li>
              <li>Expertise across apps, web, backend, and AI</li>
              <li>Smart systems powered by RAG and Agentic AI</li>
              <li>Custom solutions for unique business needs</li>
              <li>Transparent and collaborative partnership</li>
              <li>Reliable, results-driven delivery</li>
            </ul>
          </div>
        </RevealOnScroll>

        {/* RIGHT SIDE */}
        <RevealOnScroll delay={200} style={{ flex: '1 1 450px' }}>
          <div className="about-cards">
            <div className="tech-card">
              <h4>AI/ML</h4>
              <p>GPT, Claude, Gemini Integration</p>
            </div>
            <div className="tech-card">
              <h4>Java</h4>
              <p>Spring Boot, Microservices</p>
            </div>
            <div className="tech-card">
              <h4>iOS</h4>
              <p>SwiftUI, UIKit</p>
            </div>
            <div className="tech-card">
              <h4>Cloud</h4>
              <p>AWS, Azure, GCP</p>
            </div>
          </div>
        </RevealOnScroll>
      </div>
    </section>
  );
};

export default About;
